module.exports = __webpack_public_path__ + "static/img/8.418a6fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/8.png
// module id = gFcT
// module chunks = 0